<template>
  <svg class="icon" width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M26.1186 0.921184L40.702 15.5046C41.5969 16.3995 41.5969 17.8505 40.702 18.7454L26.1186 33.3288C25.2236 34.2237 23.7727
           34.2237 22.8778 33.3288C21.9829 32.4339 21.9829 30.983 22.8778 30.0881L33.5493 19.4166H2.41657C1.15097 19.4166 0.125
            18.3906 0.125 17.125C0.125 15.8594 1.15097 14.8334 2.41657 14.8334H33.5493L22.8778 4.16195C21.9829 3.26704 21.9829
             1.8161 22.8778 0.921184C23.7727 0.0262719 25.2236 0.0262719 26.1186 0.921184Z"
          fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'IconArrowRight'
}
</script>
